<!-- Мобильная модалка подробностей пометки. -->
<template>
  <BaseModal
    :visible="visible && Boolean(remark)"
    title="Пометка по ТС"
    size="lg"
    @close="$emit('close')"
  >
    <Details
      v-if="visible && remark"
      :remark="remark"
      :readonly="readonly"
      embedded
      @edit="$emit('edit')"
      @transition="$emit('transition', $event)"
    />
  </BaseModal>
</template>
<script>
import Details from "@/components/Vehicle/Remark/Details/Card.vue";
export default {
  name: "VehicleRemarkDetailsModal",
  components: { Details },
  props: {
    visible: { type: Boolean, default: false },
    remark: { type: Object, default: null },
    readonly: { type: Boolean, default: false },
  },
  emits: ["close", "edit", "transition"],
};
</script>
